import { PencilLine } from 'lucide-angular';
import {MenuAction} from '@shared/interfaces/header/menu-action';

export const connectionpointOverviewActionMenu: MenuAction[] = [
  {
    id: 'edit',
    title: 'meter.edit',
    icon: PencilLine
  }
];
